export const isRestrictedDomain = () => {
  const { hostname } = window.location
  return ['app.', 'blue.', 'green.'].some((domain) => hostname.includes(domain))
}
